import { render } from "./ReturnCreationRequestRia.vue?vue&type=template&id=9440f6c4&scoped=true"
import script from "./ReturnCreationRequestRia.vue?vue&type=script&lang=js"
export * from "./ReturnCreationRequestRia.vue?vue&type=script&lang=js"

import "./ReturnCreationRequestRia.vue?vue&type=style&index=0&id=9440f6c4&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9440f6c4"]])

export default __exports__